@if (active$ | async) {
  <div class="drawing-form">
    <ng-template #aboveDrawingButtonsContainer></ng-template>
    <div class="icon-button-list split-buttons">
      <div class="selected_feature_buttons">
        <button [class.button--active]="selectToolActive$ | async"
                i18n-tmTooltip="@@core.draw.select-modify-move-feature"
                tmTooltip="Select, modify size and/or move feature"
                mat-stroked-button
                color="primary"
                (click)="enableSelectAndModify()">
          <mat-icon svgIcon="tools_cursor"></mat-icon>
        </button>
        @if (selectedFeature) {
          <button mat-stroked-button
                  (click)="removeSelectedFeature()"
                  color="warn"
                  i18n-tmTooltip="@@core.drawing.delete-selected-drawing-object"
                  tmTooltip="Delete selected drawing object">
            <mat-icon svgIcon="remove"></mat-icon>
          </button>
          <button mat-stroked-button
                  (click)="duplicateSelectedFeature()"
                  i18n-tmTooltip="@@core.drawing.duplicate-selected-drawing-object"
                  tmTooltip="Duplicate selected drawing object">
            <mat-icon svgIcon="copy"></mat-icon>
          </button>
        }
      </div>
      @if (hasFeatures$ | async) {
        <div class="drawing_buttons">
          <button mat-stroked-button
                  (click)="removeAllFeatures()"
                  color="warn"
                  i18n-tmTooltip="@@core.drawing.delete-drawing"
                  tmTooltip="Delete complete drawing">
            <mat-icon svgIcon="close"></mat-icon>
          </button>
          <button mat-stroked-button
                  (click)="zoomToEntireDrawing()"
                  i18n-tmTooltip="@@core.drawing.zoom-to-entire-drawing"
                  tmTooltip="Zoom to show entire drawing">
            <mat-icon class="zoom_max" svgIcon="zoom_max"></mat-icon>
          </button>
        </div>
      }
    </div>

    <p class="label" i18n="@@core.drawing.draw-shape">Draw shape</p>
    <div class="icon-button-list">
      <button [class.button--active]="activeTool === 'POINT'"
              i18n-tmTooltip="@@core.draw.draw-point"
              tmTooltip="Draw point"
              mat-stroked-button
              color="primary"
              (click)="draw(drawingTypes.POINT)">
        <mat-icon svgIcon="tools_draw_point"></mat-icon>
      </button>
      <button [class.button--active]="activeTool === 'LINE'"
              i18n-tmTooltip="@@core.draw.draw-line"
              tmTooltip="Draw line"
              mat-stroked-button
              color="primary"
              (click)="draw(drawingTypes.LINE)">
        <mat-icon svgIcon="tools_draw_line"></mat-icon>
      </button>
      <button [class.button--active]="activeTool === 'POLYGON'"
              i18n-tmTooltip="@@core.draw.draw-polygon"
              tmTooltip="Draw polygon"
              mat-stroked-button
              color="primary"
              (click)="draw(drawingTypes.POLYGON)">
        <mat-icon svgIcon="tools_draw_polygon"></mat-icon>
      </button>
      <button [class.button--active]="activeTool === 'SQUARE' || activeTool === 'RECTANGLE_SPECIFIED_SIZE'"
              i18n-tmTooltip="@@core.draw.draw-square"
              tmTooltip="Draw square"
              mat-stroked-button
              color="primary"
              (click)="drawSquare()">
        <mat-icon svgIcon="tools_draw_square"></mat-icon>
      </button>
      <button [class.button--active]="activeTool === 'RECTANGLE' || activeTool === 'RECTANGLE_SPECIFIED_SIZE'"
              i18n-tmTooltip="@@core.draw.draw-rectangle"
              tmTooltip="Draw rectangle"
              mat-stroked-button
              color="primary"
              (click)="drawRectangle()">
        <mat-icon svgIcon="tools_draw_rectangle"></mat-icon>
      </button>
      <button [class.button--active]="activeTool === 'CIRCLE' || activeTool === 'CIRCLE_SPECIFIED_RADIUS'"
              i18n-tmTooltip="@@core.draw.draw-circle"
              tmTooltip="Draw circle"
              mat-stroked-button
              color="primary"
              (click)="drawCircle()">
        <mat-icon svgIcon="tools_draw_circle"></mat-icon>
      </button>
      <button [class.button--active]="activeTool === 'ELLIPSE'"
              i18n-tmTooltip="@@core.draw.draw-ellipse"
              tmTooltip="Draw ellipse"
              mat-stroked-button
              color="primary"
              (click)="draw(drawingTypes.ELLIPSE)">
        <mat-icon svgIcon="tools_draw_ellipse"></mat-icon>
      </button>
      <button [class.button--active]="activeTool === 'STAR'"
              i18n-tmTooltip="@@core.draw.draw-star"
              tmTooltip="Draw star"
              mat-stroked-button
              color="primary"
              (click)="draw(drawingTypes.STAR)">
        <mat-icon svgIcon="tools_draw_star"></mat-icon>
      </button>
      <button [class.button--active]="activeTool === 'LABEL'"
              i18n-tmTooltip="@@core.draw.draw-label"
              tmTooltip="Draw label"
              mat-stroked-button
              color="primary"
              (click)="draw(drawingTypes.LABEL)">
        <mat-icon svgIcon="tools_draw_label"></mat-icon>
      </button>
      @if (showSizeCheckbox()) {
        <mat-checkbox i18n="@@core.drawing.show-sizes-while-drawing"
                      [checked]="showMeasures()"
                      (change)="toggleMeasuring($event)">Show sizes while drawing</mat-checkbox>
      }
    </div>

    @if(activeTool === 'RECTANGLE' || activeTool === 'RECTANGLE_SPECIFIED_SIZE') {
      <div class="rectangle-size-inputs">
        <mat-form-field appearance="outline" class="rectangle-size-input__width">
          <mat-label i18n="@@core.drawing.rectangle-width">Width ({{mapUnits$ | async}})</mat-label>
          <input matInput
                 type="number"
                 [(ngModel)]="customRectangleWidth"
                 [min]="SIZE_MAX"
                 [max]="SIZE_MIN">
        </mat-form-field>
        <mat-form-field appearance="outline" class="rectangle-size-input__height">
          <mat-label i18n="@@core.drawing.rectangle-length">Length ({{mapUnits$ | async}})</mat-label>
          <input matInput
                 type="number"
                 [(ngModel)]="customRectangleLength"
                 [min]="SIZE_MAX"
                 [max]="SIZE_MIN">
        </mat-form-field>
        <button mat-icon-button (click)="clearRectangleSize()"><mat-icon svgIcon="close"></mat-icon></button>
      </div>
    }

    @if(activeTool === 'SQUARE' || activeTool === 'SQUARE_SPECIFIED_LENGTH') {
      <mat-form-field appearance="outline" class="circle-input__radius">
        <mat-label i18n="@@core.drawing.square-length">Side length ({{mapUnits$ | async}})</mat-label>
        <input matInput
               type="number"
               [(ngModel)]="customSquareLength"
               [min]="SIZE_MAX"
               [max]="SIZE_MIN">
        <button mat-icon-button matSuffix (click)="clearSquareLength()"><mat-icon svgIcon="close"></mat-icon></button>
      </mat-form-field>
    }

    @if (activeTool === 'CIRCLE' || activeTool === 'CIRCLE_SPECIFIED_RADIUS') {
      <mat-form-field appearance="outline" class="circle-input__radius">
        <mat-label i18n="@@core.drawing.circle-radius">Circle radius ({{mapUnits$ | async}})</mat-label>
        <input matInput
               type="number"
               [(ngModel)]="customCircleRadius"
               [min]="SIZE_MAX"
               [max]="SIZE_MIN">
        <button mat-icon-button matSuffix (click)="clearCircleRadius()"><mat-icon svgIcon="close"></mat-icon></button>
      </mat-form-field>
    }

    <ng-template #belowDrawingButtonsContainer></ng-template>

    <tm-drawing-objects-list [drawingLayerId]="drawingLayerId" (featureSelected)="featureSelected($event)"></tm-drawing-objects-list>
    @if (selectedDrawingType) {
      <tm-drawing-style-form
        [type]="selectedDrawingType"
        [style]="style()"
        [onlyLabelSettings]="lockedStyle()"
        (styleUpdated)="featureStyleUpdates($event)"
        (labelStyleUpdated)="featureLabelStyleUpdates($event)"></tm-drawing-style-form>
      @if (lockedStyle()) {
        <div class="locked-style" i18n="@@core.drawing.locked-style">The style for this drawing object cannot be changed.</div>
      }
    }
  </div>
}
